var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-center"},[_c('h1',[_c('i',{staticClass:"fal fa-circle-notch fa-spin"}),_vm._v(" Laster...")])])}]

export { render, staticRenderFns }